import { useState } from 'react';
import '../App.css';

function Contact() {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        message: ''
    });
    const [status, setStatus] = useState(null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus('loading');

        try {
            const response = await fetch('https://formsubmit.co/ajax/support@fiveguycarrentals.com', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json'
                },
                body: JSON.stringify(formData)
            });

            if (response.ok) {
                setStatus('success');
                setFormData({ name: '', email: '', phone: '', message: '' });
            } else {
                setStatus('error');
            }
        } catch (err) {
            console.error(err);
            setStatus('error');
        }
    };

    return (
        <section className="cta contact-page">
            <div className="container py-5">
                <div className="cta-content">
                    <div className="cta-text">
                        <h2>Let's Connect</h2>
                        <p>
                            Have questions or ready to elevate your car rental business? Contact
                            us today, and we'll help you get started.
                        </p>
                        <div className="cta-divider"></div>
                        <p className="cta-highlight">
                            🚗 <em>Join thousands of businesses using Fleetify to simplify their car rental operations. Your success starts here!</em>
                        </p>
                    </div>

                    <div className="cta-form">
                        <form className="contact-form" onSubmit={handleSubmit}>
                            <div className="form-group">
                                <label htmlFor="name">Name</label>
                                <input
                                    type="text"
                                    id="name"
                                    name="name"
                                    placeholder="Enter your name"
                                    required
                                    value={formData.name}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="email">Email</label>
                                <input
                                    type="email"
                                    id="email"
                                    name="email"
                                    placeholder="Enter your email"
                                    required
                                    value={formData.email}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="phone">Phone Number</label>
                                <input
                                    type="tel"
                                    id="phone"
                                    name="phone"
                                    placeholder="Enter your phone number"
                                    required
                                    value={formData.phone}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="message">Message</label>
                                <textarea
                                    id="message"
                                    name="message"
                                    rows="4"
                                    placeholder="Write your message"
                                    required
                                    value={formData.message}
                                    onChange={handleChange}
                                ></textarea>
                            </div>
                            <button type="submit" className="btn btn-primary cta-btn">
                                Send Message
                            </button>

                            {/* Feedback status */}
                            {status === 'loading' && <p>Sending...</p>}
                            {status === 'success' && <p className="success">Message sent successfully!</p>}
                            {status === 'error' && <p className="error">Something went wrong. Please try again.</p>}
                        </form>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Contact;
